import React, { useCallback } from "react";

import SelectDropdown from "../SelectDropdown/SelectDropdown";
import ImageInput from "../ImageInput/ImageInput";
// import DateTimePicker from "../DateTimePicker/DateTimePicker";
import DatePicker from "app/Components/DateTimeCustom/DateRangePickerCustom";
import { FiCalendar } from "react-icons/fi";

export const EFormFieldInputTypes = {
  text: "text",
  textarea: "textarea",
  number: "number",
  date: "date",
  time: "time",
  image: "image",
  dateTime: "date-time",
  file: "file",
  email: "email",
  password: "password",
  select: "select",
  multiSelect: "multi-select",
  searchableSelect: "searchable-select",
  dateRange: "date-range",
};

export default function FormField({
  name,
  viewName,
  title = "Title",
  inputType,
  placeholder,
  value,
  viewValue,
  onChange,
  options,
  getOptions,
  required,
  accept,
  initialValue,
  readOnly,
  max,
  min,
  height,
  width,
  startDate,
  endDate,
  handleDateRange,
  hideEmptyOption,
}) {
  const onInputChange = useCallback(
    (event) =>
      inputType === EFormFieldInputTypes.number &&
      max &&
      !isNaN(event.key) &&
      (+event.target.value > max || +(event.target.value + event.key) > max) &&
      event.preventDefault(),
    [inputType, max]
  );

  switch (inputType) {
    case EFormFieldInputTypes.image:
      return (
        <ImageInput
          name={name}
          value={value}
          viewName={viewName}
          onChange={onChange}
          viewValue={viewValue}
          accept={accept}
          height={height}
          width={width}
        />
      );
    case EFormFieldInputTypes.select:
    case EFormFieldInputTypes.multiSelect:
    case EFormFieldInputTypes.searchableSelect:
      return (
        <SelectDropdown
          name={name}
          viewName={viewName}
          title={title}
          onChange={onChange}
          options={options}
          value={value}
          getOptions={getOptions}
          required={required}
          initialValue={initialValue}
          placeholder={placeholder}
          readOnly={readOnly}
          hideEmptyOption={hideEmptyOption}
          asSearchable={inputType === EFormFieldInputTypes.searchableSelect}
          multiple={inputType === EFormFieldInputTypes.multiSelect}
        />
      );
    case EFormFieldInputTypes.dateRange:
      return (
        <div className="d-flex align-items-center drilingView-bx mb-0 dateRangeCol">
          <div className="pr-3">
            <FiCalendar size="24" color="#00b5ef" />
          </div>
          <div>
            <h5>Date Range</h5>
            <DatePicker
              handleSelect={handleDateRange}
              startDate={startDate}
              endDate={endDate}
              placeholder="Since Inception"
            />
          </div>
        </div>
      );
    // case EFormFieldInputTypes.date:
    // case EFormFieldInputTypes.time:
    // case EFormFieldInputTypes.dateTime:
    //   return (
    //     <DateTimePicker
    //       value={value}
    //       name={name}
    //       onChange={onChange}
    //       isValidDate={isValidDate}
    //       type={inputType}
    //       required={required}
    //       readOnly={readOnly}
    //       dateFormat={dateFormat}
    //     />
    //   );
    case EFormFieldInputTypes.textarea:
      return (
        <textarea
          className="form-control"
          name={name}
          onChange={onChange}
          readOnly={readOnly}
          placeholder={placeholder || `Enter ${title}`}
        />
      );
    case EFormFieldInputTypes.text:
    case EFormFieldInputTypes.email:
    case EFormFieldInputTypes.password:
    default:
      return (
        <input
          className="form-control"
          name={name}
          type={inputType}
          placeholder={placeholder || `Enter ${title}`}
          onKeyDown={onInputChange}
          value={inputType === EFormFieldInputTypes.file ? undefined : value}
          onChange={onChange}
          accept={accept}
          max={max}
          min={min}
          readOnly={readOnly}
        />
      );
  }
}
